import React, { useState, useEffect } from 'react';
import Navbar from './Navbar/Navbar'
import NavbarMobile from './NavbarMobile'
import { TextField, InputAdornment, Box } from "@mui/material";
import { ReactComponent as SearchIcon } from "Assets/icons/search.svg";
import { ReactComponent as UserIcon } from "Assets/icons/user.svg";
import { useTranslation } from "react-i18next";
import {
    Container,
    Nav,
} from "react-bootstrap";
import LogoImg from "Assets/Images/logo.svg";
import LanguageSwitcher from './LanguageSwitcher'


export const Header = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const [searchValue, setSearchValue] = React.useState("");
    return (
        <header>
          
            <div className="container-fluid">
                <div className="top-wrap">
                    <div className="d-flex flex-sm-nowrap align-items-center justify-content-between flex-md-nowrap w-100">
                        <a className="navbar-brand align-items-center me-0 logo-spacing py-0" href="/">
                            <img src={LogoImg} className="logo" alt="bourse energy iee" />
                        </a>
                        <Navbar />
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",      
                                gap: 1
                            }}
                        >
                            <span className="new-badge text-center" style={{
                                height: "20px",
                                lineHeight: 1.7
                            }}>
                                <a href="https://oldsite.iee.ir/" className="mx-0 text-white fw-bold" target="_blank">{t('old_website')}</a>
                            </span>
                            <TextField
                                variant="outlined"
                                placeholder={t('search') }
                                size="small"
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                sx={{
                                    width: 200,
                                    backgroundColor: "#fff",
                                    borderRadius: "25px",
                                    
                                    "& input": {
                                        padding: "6px 8px !important",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "25px",
                                        paddingRight: "8px",
                                        paddingLeft:"10px",
                                        flexDirection: "row-reverse",

                                    },
                                    
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <div className="language-bar d-flex justify-content-end align-items-center d-lg-flex">
                                {<LanguageSwitcher />}
                            </div>
                            <div className="header-user-login d-none">
                                <UserIcon />
                            </div>
                        </Box>                        
                        <NavbarMobile />
                    </div>
                </div>
            </div>
        </header>
    );
}
export default Header;